"use strict";import{TabPanel as e}from"./src/TabPanel.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-tab-panel",e);
//# sourceMappingURL=sp-tab-panel.js.map
